"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.XpMultiplierToJSON = exports.XpMultiplierFromJSONTyped = exports.XpMultiplierFromJSON = void 0;
var runtime_1 = require("../runtime");
function XpMultiplierFromJSON(json) {
    return XpMultiplierFromJSONTyped(json, false);
}
exports.XpMultiplierFromJSON = XpMultiplierFromJSON;
function XpMultiplierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'amount': json['amount'],
        'createdAt': json['createdAt'],
        'expiresAt': json['expiresAt'],
    };
}
exports.XpMultiplierFromJSONTyped = XpMultiplierFromJSONTyped;
function XpMultiplierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'amount': value.amount,
        'createdAt': value.createdAt,
        'expiresAt': value.expiresAt,
    };
}
exports.XpMultiplierToJSON = XpMultiplierToJSON;
